export default class Department {
  constructor({ label, value }) {
    this.value = value;
    this.label = label;
  }

  getLabel() {
    return this.label;
  }

  getValue() {
    return this.value;
  }
}
